import { useContext, useEffect, useState } from "react";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { AppRulesContext } from "../../App";
import TaxExpertsApi from "../../api/TaxExpertsApi";
import PageHeader from "../../components/PageHeader";
import CardLoader from "../../components/content-loader/CardLoader";
import { NothingAvailable } from "../../components/placeholders";
import AdminExpertFilings from "../../components/tabs/users/AdminExpertFilings";
import AdminUserCP from "../../components/tabs/users/AdminUserCP";
import AdminUserProfile from "../../components/tabs/users/AdminUserProfile";
import { EToastvariant, IUserResponse } from "../../config/interfaces";
import { useAppDispatch } from "../../redux/Store";
import { showToastMsg } from "../../redux/slice/ToastMsgSlice";
import { UtilService } from "../../services";

const TaxExpertDetails = () => {
  const dispatch = useAppDispatch();
  const [isFetching, setIsFetching] = useState(true);
  const [taxExpertData, setTaxExpertData] = useState<IUserResponse>();
  const { uUId } = useParams();
  const navigate = useNavigate();
  const { rulesSvc } = useContext(AppRulesContext);

  const { pathname } = useLocation();
  const pathName = pathname.split("/");

  useEffect(() => {
    getTaxExpertDetails();
  }, []);

  const getTaxExpertDetails = async () => {
    try {
      if (!uUId) {
        return;
      }

      setIsFetching(true);
      const taxExpertsApi = TaxExpertsApi.getInstance();
      const response = await taxExpertsApi.getTaxExpertById(uUId);
      const _data = response;
      setTaxExpertData(_data);
    } catch (error) {
      dispatch(
        showToastMsg({
          isVisible: true,
          title: "Error",
          message: UtilService.getErrorMessage(error),
          variant: EToastvariant.Danger
        })
      );
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <>
      <Container className="w-800">
        {isFetching ? (
          <>
            <PageHeader backIconButton={true} title="Tax Expert" />
            <CardLoader cardType="details" />
          </>
        ) : taxExpertData?.uuid ? (
          <>
            <PageHeader
              backIconButton={true}
              title={taxExpertData?.fullName || ""}
              titleClass="text-capitalize"
            />
            <div className="tabs-wrapper">
              <Tabs defaultActiveKey="profile" id="eds-admin-settings">
                {/* Profile tab  */}
                <Tab eventKey="profile" title="Profile">
                  <AdminUserProfile pageName="tax-experts" />
                </Tab>

                {/* Filings by User tab  */}
                {rulesSvc.canAccess(rulesSvc.eFilingList) && (
                  <Tab eventKey="filings" title="Filings by User">
                    <AdminExpertFilings />
                  </Tab>
                )}

                {/* Change Password tab  */}
                {rulesSvc.canAccess(rulesSvc.userChangePassword) && (
                  <Tab eventKey="change-password" title="Change Password">
                    <AdminUserCP pageName="tax-experts" />
                  </Tab>
                )}
              </Tabs>
            </div>
          </>
        ) : (
          <>
            <div className="text-center my-5">
              <NothingAvailable
                title="Something Went Wrong"
                message="Failed to fetch data from the server. Please try again later."
                btnTitle="Go to Tax Experts"
                onBtnPress={() => navigate(`/${pathName[1]}`, { replace: true })}
                btnRules={rulesSvc.usersList}
              />
            </div>
          </>
        )}
      </Container>
    </>
  );
};

export default TaxExpertDetails;
